import React from "react";
import { Mail, Phone, Home, Building2, HardHat, PencilRuler } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-[#f4f2ee] text-gray-800 flex flex-col dark:bg-[#f4f2ee] dark:text-gray-800">
      
      {/* Top Bar */}
      <div className="flex justify-between items-center px-6 md:px-16 py-6">
        
        {/* Clickable Logo + Text */}
        <a href="/" className="flex items-center gap-3">
          <img
            src="/logo.png"
            alt="Garnkirk Construction Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
          <div>
            <h1 className="font-semibold tracking-widest text-sm md:text-base">
              GARNKIRK CONSTRUCTION
            </h1>
            <p className="text-xs tracking-widest">INC.</p>
          </div>
        </a>

        <div className="hidden md:flex gap-6 text-sm items-center">
          <a
            href="mailto:tahirbcn1987@gmail.com"
            className="flex items-center gap-2 hover:text-[#c9a46c] transition"
          >
            <Mail size={16} />
            <span>tahirbcn1987@gmail.com</span>
          </a>

          <a
            href="tel:+16475696302"
            className="flex items-center gap-2 hover:text-[#c9a46c] transition"
          >
            <Phone size={16} />
            <span>+1-647-569-6302</span>
          </a>
        </div>
      </div>

      {/* Hero */}
      <div className="flex-1 grid md:grid-cols-2 items-center px-6 md:px-16 py-10">
        <div>
          <p className="tracking-[0.3em] text-sm mb-4">OUR NEW WEBSITE IS</p>

          <h2 className="text-5xl md:text-6xl font-bold leading-tight">
            COMING
            <br />
            <span className="text-[#c9a46c]">SOON</span>
          </h2>

          <div className="w-16 h-[2px] bg-[#c9a46c] my-6"></div>

          <p className="text-gray-600 dark:text-gray-600 max-w-md mb-6">
            We’re working hard to build a better experience for you. Our new
            website is under construction and will be launching soon.
          </p>
        </div>

        <div className="hidden md:block">
          <img
            src="/cons.jpg"
            alt="construction"
            className="rounded-xl shadow-xl grayscale"
          />
        </div>
      </div>

      {/* Services */}
      <div className="px-6 md:px-16 pb-10">
        <div className="bg-white dark:bg-white rounded-2xl shadow-md p-6 md:p-10">
          <h3 className="text-center tracking-[0.3em] text-sm mb-8 text-[#c9a46c]">
            WHAT WE DO
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-sm">
            <div className="flex flex-col items-center gap-2">
              <Home className="text-[#c9a46c]" />
              <p className="font-semibold">Residential</p>
              <p className="text-gray-500 dark:text-gray-500">Construction</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Building2 className="text-[#c9a46c]" />
              <p className="font-semibold">Commercial</p>
              <p className="text-gray-500 dark:text-gray-500">Construction</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <HardHat className="text-[#c9a46c]" />
              <p className="font-semibold">Project</p>
              <p className="text-gray-500 dark:text-gray-500">Management</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <PencilRuler className="text-[#c9a46c]" />
              <p className="font-semibold">Design &</p>
              <p className="text-gray-500 dark:text-gray-500">Planning</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="px-6 md:px-16 pb-10">
        <div className="bg-[#2d2d2d] text-white dark:bg-[#2d2d2d] dark:text-white rounded-2xl p-6 md:p-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full border border-[#c9a46c] flex items-center justify-center">
              ⏱
            </div>
            <div>
              <p className="text-sm opacity-70">STAY TUNED</p>
              <h4 className="text-lg font-semibold">
                Great things are on the way.
              </h4>
            </div>
          </div>

          <div className="flex gap-4">
            <a
              href="tel:+16475696302"
              className="bg-[#c9a46c] text-black px-4 py-2 rounded-lg text-sm font-medium"
            >
              Call Now
            </a>
            <a
              href="mailto:tahirbcn1987@gmail.com"
              className="border border-[#c9a46c] px-4 py-2 rounded-lg text-sm"
            >
              Email Us
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#2d2d2d] text-white dark:bg-[#2d2d2d] dark:text-white px-6 md:px-16 py-6 text-sm flex flex-col md:flex-row justify-between items-center gap-4">
        
        {/* Footer Logo */}
        <a href="/" className="flex items-center gap-2">
          <img
            src="/logo.png"
            alt="Garnkirk Construction Logo"
            className="h-8 md:h-10 w-auto object-contain"
          />
        </a>

        <span>121 - 1468 Victoria Park Ave, Toronto ON M4C 5L7</span>

        <a href="tel:+16475696302" className="hover:text-[#c9a46c]">
          +1-647-569-6302
        </a>

        <a
          href="mailto:tahirbcn1987@gmail.com"
          className="hover:text-[#c9a46c]"
        >
          tahirbcn1987@gmail.com
        </a>
      </footer>
    </div>
  );
}